export const flattenAndSortSoftwareByFunction = (
    softwareByFunction: Record<string, string[]> | undefined,
): string[] => {
    return softwareByFunction
        ? [
              ...new Set(
                  Object.values(softwareByFunction)
                      .flat()
                      .map((software) => software.toUpperCase()),
              ),
          ].sort((a, b) => a.localeCompare(b))
        : [];
};
